import { render, staticRenderFns } from "./linkGroup.vue?vue&type=template&id=ef1baf2e&scoped=true&"
import script from "./linkGroup.vue?vue&type=script&lang=js&"
export * from "./linkGroup.vue?vue&type=script&lang=js&"
import style0 from "./linkGroup.vue?vue&type=style&index=0&id=ef1baf2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1baf2e",
  null
  
)

export default component.exports